import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { NativeSection, NativeContract, IndexWrapper, ServiceType } from "@framework/shared";

export const nativeRoutes: Array<RouteObject> = [
  {
    path: "/native",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="native">
            <NativeSection service={ServiceType.ADMIN} />
          </IndexWrapper>
        ),
      },
      {
        path: "/native/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <NativeContract service={ServiceType.ADMIN} /> },
          { path: "/native/contracts/:id/:action", element: <NativeContract service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
